import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

/// LISTADO DE PASOS DE WIZARD DE CADA PRODUCTO
import { certificarSteps } from './certificar/certificar.steps';
import { medirSteps } from './medir/medir.steps';
import { pulseSteps } from './pulse/pulse.steps';
import { focusSteps } from './focusa/focus.steps';

//PASOS DE PRODUCTOS MEDIR
import { medirT1Steps } from './medir/tipo_1/tipo_1.steps';
import { medirT2Steps } from './medir/tipo_2/tipo_2.steps'; // MTS
import { medirT3Steps } from './medir/tipo_3/tipo_3.steps'; // Areas
import { medirT4Steps } from './medir/tipo_4/tipo_4.steps'; // Lideres
import { medirT5Steps } from './medir/tipo_5/tipo_5.steps'; // Dimenciones
import { medirT6Steps } from './medir/tipo_6/tipo_6.steps'; // Certificar
//PASOS DE PRODUCTOS CERTIFICAR
import { certificarT1Steps, certificarIzzi } from './certificar/tipo_1/tipo_1.steps';
import { certificarT2Steps } from './certificar/tipo_2/tipo_2.steps';
import { certificarT2StepsTemplate } from './certificar/tipo_2/tipo_2.steps';
import { certificarT2StepsCerPlata } from './certificar/tipo_2/tipo_2.steps';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_izzi } from 'app/idiomas/i18n/Izzi/izzi.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import *  as $ from 'jquery';
import {AuthService} from 'app/auth/auth.service';
import { WizardService } from './services/wizard.service';
import {TranslateService} from '@ngx-translate/core';
import { ModalWizardComponent } from "./modal-wizard/modal-wizard.component";


const moment = require('moment');

@Component({
  selector: 'wizard-cgo',
  templateUrl: './wizard-cgo.component.html',
  styleUrls: ['./wizard-cgo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class WizardCGOComponent{

  animationDirection: 'left' | 'right' | 'none';
  currentStep: number;
  lastStep: number;
  iconoStep: any = {
    undone: 'lock',
    pending: 'more_horiz',
    done: 'done'
  };

  pasosWizard: any;
  tituloProducto: string;
  tipoProducto: string;
  idiomaActual:string;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  // Plantilla de certificar para validacion
  idPlantilla:any;
  // objeto statuses
  statusSteps: backInter.getAllStatus;
  statusStepsFocus: any;
  // datos producto vigente
  productoVigente: any;
  // año producto productoVigente
  anioProducto: number;

  //booleans de los steps
  stp1Ok = false;

  stpAllOk = false;

  //mensaje enviado desde components hijos al component wizard CGO
  mensajeEntreComponents: string;

  idiomaVideo:string;

  //booleans secciones removibles
  hasForall = true;
  hasDemog = true;
  hasAdici = true;
  hasReact = true;
  hasOpen = true;
  //booleans secciones removibles
  hasForallT1 = true;
  hasDemogT1 = true;
  hasAdiciT1 = true;
  hasReactT1 = true;
  hasOpenT1 = true;
  hasNpsT1=true;
  hasControlT1=true;
  instituto:any;

  seccionesDisponibles = {
    Forall: false,
    Demograficos: false,
    Adicionales: false,
    Reactivos: false,
    Abiertas: false,
    NPS: false,
    Control: false
  };



  listaProdsMedir: any[] = [];
  listaProdsPulse: any[] = [];
  listaProdsFocus: any[] = [];
  listaProdsCerAmco: any[] = [];
  idsProductosCert3Falsos = [
    {id:41, activo: false}, // medir 3.0
    {id:42, activo: false}, // pulse check 3.0
    {id:43, activo: false}, // focus 3.0
    {id:56, activo: false}, // focus 3.0
    {id:57, activo: false}, // focus 3.0
    {id:58, activo: false}, // focus 3.0
  ];

  fechaPasoVoice = "2021-11-28";
  mostrarPasoVoice: boolean;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _fuseSidebarService: FuseSidebarService,
    private dialog: MatDialog,
    public authService: AuthService,
    private wizardService: WizardService,
    private translateSrv: TranslateService,
    private activatedRoute:ActivatedRoute,
  )
  {
    this.statusSteps = null;
    this.statusStepsFocus = null;
    this.tipoProducto = null;
    this.animationDirection = 'none';
    this.currentStep = 0;
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_izzi.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    // orden de actualizacion de botones del wizard
    this.wizardService.mensajeActual.subscribe( (resu) => {
      this.mensajeEntreComponents = resu;
      switch(this.mensajeEntreComponents){
        case "100":
        this.getTodosLosStatus();
          // this.validarProductoActualCorrecto(); //pasa por un filtro que revisa todos los productos almacenados en caché y obtiene el bueno para hacer el get secciones, no tengo idea porque se quedan y/o porque no se borran los que no son, ahi luego lo arreglo alv
        // this.getSeccionesProducto(this.tipoProducto,"via 2");
        // this.obtieneProductoActual(this.tipoProducto);
        break;
      }
    });

    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; this.cambiaIdiomaVideo(this.idiomaActual,this.currentStep); });

  }

  async getInfoEmpresa(){
    const datosEmp:any = await this.wizardService.getInfoEmpresa(localStorage.getItem('companyID')).toPromise();//.subscribe((respuesta:any) => {
    console.log("getInfoEmpresa:",datosEmp);
    if(moment(datosEmp.createdAt).isAfter(moment(this.fechaPasoVoice)) ){
      console.log('si la fecha es posterior a la indicada, nueva version');
        //si la fecha es posterior a la indicada, nueva version
        const banderaConfigVoice:any = await this.wizardService.getBanderaConfigVoiceSecc().toPromise().then((respuesta:any)=>{
          console.log("bandera config voice:",respuesta);

          return respuesta.configVoiceSection;
        });//.subscribe((respuesta:any) => {
          if (banderaConfigVoice) {
            let datos={
              productoId: localStorage.getItem('productoID'),
              warning_audio: 1
            }
            this.wizardService.getStatusModal(datos).subscribe((respuesta:any)=>{
              console.log('respuesta=====',respuesta);
              if(respuesta.estatus==1){
                this.modalAlertSecciConfiVoice();
              }

            });

          }

      // this.mostrarPasoVoice = true;
      this.mostrarPasoVoice = banderaConfigVoice;
    } else{
      console.log('NOOOOOOOOOOOOOO  fecha es posterior a la indicada, nueva version');
      this.mostrarPasoVoice = false;
    }
    this.obtieneOrigen();
    // });
  }

  updateStatusModal(){
    let datos={
      productoId: localStorage.getItem('productoID'),
      warning_audio: 2
    };
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
    });
  }

  modalAlertSecciConfiVoice(){
    const dialogRef = this.dialog.open(ModalWizardComponent,
        {
        width: '23%',
        height: '40%',
        panelClass: ['animate__animated','animate__slideInLeft'],
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);

        if (result==true) {
          this.updateStatusModal();
        }
      });
  }

  validarProductoActualCorrecto(){
    let nombreCampoId: string;
    let nombreCampoFecha: string;
    switch(this.tipoProducto){
      case "1": case "c1": case "c2": case "c3": case "m7": case "p1": case "f1": case "am1": case "td1": case "pe1":case "c4Plata": case "c6":
        nombreCampoFecha = "fechaCertificar";
        nombreCampoId = "idCertificar";
      break;
      case "2": nombreCampoFecha = "fechaMedir"; nombreCampoId = "idMedir"; break;
      case "3": nombreCampoFecha = "fechaPulseCheck"; nombreCampoId = "idPulseCheck"; break;
      case "4": nombreCampoFecha = "fechaFocus"; nombreCampoId = "idFocusArea"; break;
      case "m1": case "m2": case "m3": case "m4": case "m5": case "m6":
        nombreCampoFecha = "fechaProducto"; nombreCampoId = "idProducto";
      break;
    }
    if(this.productoVigente[nombreCampoId] == localStorage.getItem("productoID") && this.productoVigente[nombreCampoFecha] == localStorage.getItem("fechaProducto")){
      console.log("este es el producto correcto:",this.productoVigente);
      this.getSeccionesProducto(this.tipoProducto,"via 2");
    }
    else{
      console.log("este no es el producto correcto:",this.productoVigente);
    }
  }

  ngOnInit(): void
  {
    // this.limpiaVariables();
    this.getInfoEmpresa();

    this.obtieneInstituto();
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; break;
      case '11': case 'BR': this.instituto = 'BR'; break;
      case '14': case 'GCTI': this.instituto = 'GCTI'; break;
      case '15': case 'ESP': this.instituto = 'ESP'; break;
    }
    console.log("INSTITUTO "+this.instituto);
  }

  cambiaIdiomaVideo(idioma:string, step:number){
    this.idiomaVideo = this.translateSrv.currentLang;
    // switch(idioma){
    //   case 'es': this.idiomaVideo = idioma; break;
    //   default: this.idiomaVideo = 'en';
    // }
    setTimeout( () => {
      // let url = './assets/video/wizard/certificar/banner/' + this.idiomaVideo + '/' + this.pasosWizard[step].videoBanner + '.mp4';
      console.log(this.pasosWizard);
      console.log(step);
      let url = DATOS_API.urlAssets + 'video/wizard/certificar/banner/' + this.idiomaVideo + '/' + this.pasosWizard[step].videoBanner + '.mp4';
      console.log("URL");
      console.log(url);
      $("#videoBanner"+step).attr("src",url);
    },200);
  }

  obtieneOrigen(){
    this.activatedRoute.data.subscribe(params => {
      // console.log(params.producto);
      switch(params.producto){
        case "1":
        this.pasosWizard = certificarSteps;
        this.tituloProducto = 'WIZARD.CERTIFICAR.TITULO';
        break;
        case "2":
        this.pasosWizard = medirSteps;
        this.tituloProducto = 'WIZARD.MEDIR.TITULO';
        break;
        case "3":
        this.pasosWizard = pulseSteps;
        this.tituloProducto = 'WIZARD.PULSE.TITULO';
        break;
        case "4":
        this.pasosWizard = focusSteps;
        this.tituloProducto = 'WIZARD.FOCUS.TITULO';
        break;
        //PRODUCTOS MEDIR
        case "m1":
        this.pasosWizard = medirT1Steps;
        this.tituloProducto = 'WIZARD.MEDIR_M1.TITULO';
        break;
        case "m2":
        this.pasosWizard = medirT2Steps;
        this.tituloProducto = 'WIZARD.MEDIR_M2.TITULO';
        break;
        case "m3":
        this.pasosWizard = medirT3Steps;
        this.tituloProducto = 'WIZARD.MEDIR_M3.TITULO';
        break;
        case "m4":
        this.pasosWizard = medirT4Steps;
        this.tituloProducto = 'WIZARD.MEDIR_M4.TITULO';
        break;
        case "m5":
        this.pasosWizard = medirT5Steps;
        this.tituloProducto = 'WIZARD.MEDIR_M5.TITULO';
        break;
        case "m6":
        this.pasosWizard = medirT6Steps;
        this.tituloProducto = 'WIZARD.MEDIR_M6.TITULO';
        break;
        //PRODUCTOS CERTIFICAR 2.0 y 3 para nuevo instituto
        case "c1":
        this.pasosWizard = certificarT1Steps;
        if(localStorage.getItem("institutoValidacionEtiquetas")!="15"){
          this.tituloProducto = 'WIZARD.CERTIFICAR.TITULO';
        }
        else{
          this.tituloProducto = 'WIZARD.CERTIFICAR.TITULO_ESPAIN';
        }
        break;
        case "c2":
          this.pasosWizard = certificarIzzi;
          this.tituloProducto = 'WIZARD.IZZI.TITULO';
        break;
        case "c4Plata":
          this.pasosWizard = certificarT2StepsCerPlata;
          this.tituloProducto = 'WIZARD.CERTIFICAR_C4.TITULO';
        break;
        case "c3": case "m7": case "p1": case "f1": case "am1": case "td1": case "pe1": case "c6":
          if(localStorage.getItem("userBypass")){
            console.log("muuestra secciones Itbm o GPTW");
            this.pasosWizard = certificarT2StepsTemplate;
          }else{
            console.log("muuestra secciones Empresa");
            this.pasosWizard = certificarT2Steps;
          }
          if(params.producto == "c3"){
            this.tituloProducto =localStorage.getItem('instituto_id') == '19' ? 'WIZARD.MEDIR_M9.TITULO' : 'WIZARD.CERTIFICAR.TITULO';
          }
          else if(params.producto == "m7"){
            if(localStorage.getItem('instituto_id') == '18'){
              this.tituloProducto = 'WIZARD.MEDIR_M8.TITULO';
            }else if(localStorage.getItem('instituto_id') == '19'){
              this.tituloProducto = 'WIZARD.MEDIR_M9.TITULO';
            }else{
              this.tituloProducto = 'WIZARD.MEDIR_M7.TITULO';
            }
          }
          else if(params.producto == "p1"){
            this.tituloProducto = 'WIZARD.PULSE_T1.TITULO';
          }
          else if(params.producto == "f1"){
            this.tituloProducto = 'WIZARD.FOCUS_1.TITULO';
          }else if (params.producto == "am1") {
            this.tituloProducto = 'WIZARD.Amco.TITULO';
          }else if (params.producto == "td1") {
            this.tituloProducto = 'WIZARD.Trabajo_digno.TITULO';
          }else if (params.producto == "pe1") {
            this.tituloProducto = 'WIZARD.Primer_empleo.TITULO';
          }else if (params.producto == "c6") {
            this.tituloProducto = 'WIZARD.CERTIFICAR_C6.TITULO';
          }
          console.log("mostrarPasoVoice:",this.mostrarPasoVoice);
          let pasoVoice = this.pasosWizard.find(item => item.id == 'voice');
          pasoVoice.visible = this.mostrarPasoVoice;
        break;
      }
      let wizardOriginal = JSON.parse(JSON.stringify(this.pasosWizard));
      console.log("wizardOriginal:",wizardOriginal);

      this.limpiaVariables();
      this.tipoProducto = params.producto;
      localStorage.setItem('tipoProducto', params.producto);
      this.obtieneProductoActual(params.producto);

      this.idiomaActual = this.translateSrv.currentLang;
      this.cambiaIdiomaVideo(this.idiomaActual,0);
    });
  }

  limpiaVariables(){
    console.log("limpia variables del wizard");

    this.productoCertificar = null;
    this.statusSteps = null;
    this.statusStepsFocus = null;
    this.productoVigente = null;
    this.pasosWizard.forEach(paso => {
      paso.status = 1;
      // paso.visible = false;
    });
  }

  filtraProductosMedir(productos:backInter.infoProductos){
    this.listaProdsMedir = [];
    this.listaProdsPulse = [];
    this.listaProdsFocus = [];
    this.listaProdsCerAmco = [];
    //declaración de arreglos de productos medir
    let arrayMedir_0:any[] = [];
    let arrayMedir_1:any[] = [];
    let arrayMedir_2:any[] = [];
    let arrayMedir_3:any[] = [];
    let arrayMedir_4:any[] = [];
    let arrayMedir_5:any[] = [];
    let arrayMedir_6:any[] = [];
    let arrayMedir_7:any[] = [];
    //declaración de arreglos de productos pulse
    let arrayPulse_0:any[] = [];
    let arrayPulse_1:any[] = [];
    let arrayFocus_0:any[] = [];
    let arrayFocus_1:any[] = [];
    let arrayCerAmco:any[] = [];
    let arrayCerTraDig:any[] = [];
    let arrayCerPriEmp:any[] = [];

    productos.productosCertificar.forEach((producto:any) => {
      if(this.idsProductosCert3Falsos.findIndex(item => item.id == producto.idProducto) == -1){ //si el id del producto no esta en el arreglo

      }
      else{
        switch (producto.idProducto) {
          case 41:  //medir 3.0
            arrayMedir_7.push(producto);
            this.idsProductosCert3Falsos[0].activo = true;
          break;
          case 42:  //pulse 3.0
            arrayPulse_1.push(producto);
            this.idsProductosCert3Falsos[1].activo = true;
          break;
          case 43:  //focu 3.0
            arrayFocus_1.push(producto);
            this.idsProductosCert3Falsos[2].activo = true;
          break;
          case 56:  //focu 3.0
            arrayCerAmco.push(producto);
            this.idsProductosCert3Falsos[3].activo = true;
          break;
          case 57:  //focu 3.0
            arrayCerTraDig.push(producto);
            this.idsProductosCert3Falsos[4].activo = true;
          break;
          case 58:  //focu 3.0
            arrayCerPriEmp.push(producto);
            this.idsProductosCert3Falsos[5].activo = true;
          break;
        }
      }
    });
    console.log('arrayPulse_1',arrayPulse_1);

    productos.productosMedir.forEach(producto => {
      arrayMedir_0.push(producto);
    });
    productos.productosMedir2.forEach(producto => {
      switch(producto.tipo){
        case 1: arrayMedir_1.push(producto); break;
        case 2: arrayMedir_2.push(producto); break;
        case 3: arrayMedir_3.push(producto); break;
        case 4: arrayMedir_4.push(producto); break;
        case 5: arrayMedir_5.push(producto); break;
        case 6: arrayMedir_6.push(producto); break;
      }
    });

    //filtrado de pulse
    productos.productosPulseCheck.forEach(producto => {
      arrayPulse_0.push(producto);
    });
    //filtrado de pulse
    productos.productosFocusArea.forEach(producto => {
      arrayFocus_0.push(producto);
    });


    this.listaProdsMedir.push(
      {id:2, lista: arrayMedir_0},
      {id:11, lista: arrayMedir_1},
      {id:12, lista: arrayMedir_2},
      {id:13, lista: arrayMedir_3},
      {id:14, lista: arrayMedir_4},
      {id:15, lista: arrayMedir_5},
      {id:16, lista: arrayMedir_6},
      {id:41, lista: arrayMedir_7}, //medir 3.0
    );
    this.listaProdsCerAmco.push(
      {id:56, lista: arrayCerAmco},
      {id:57, lista: arrayCerTraDig},
      {id:58, lista: arrayCerPriEmp},
    );

    this.listaProdsPulse.push(
      {id:4, lista: arrayPulse_0},
      {id:42, lista: arrayPulse_1},
    );
    this.listaProdsFocus.push(
      {id:4, lista: arrayFocus_0},
      {id:43, lista: arrayFocus_1},
    );
console.log('listaProdsPulse',this.listaProdsPulse);

  }


  /// obtiene el producto solicitado vigente
  obtieneProductoActual(tipoProducto:string){
    this.wizardService.getProductos().subscribe((data:backInter.infoProductos) => {
      // let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      console.log(data);
      let pulsecheckXAno:any[]=[];
      let focusAreaXAno:any[]=[];
      this.filtraProductosMedir(data);
      let productoSolicitado:any;
      switch(tipoProducto){
        case "1": productoSolicitado = data.productosCertificar; break;
        case "2": productoSolicitado = data.productosMedir; break;
        case "3": productoSolicitado = data.productosPulseCheck; break;
        case "4": productoSolicitado = data.productosFocusArea; break;
        //PRODUCTOS MEDIR
        case "m1": productoSolicitado = this.listaProdsMedir[1].lista; break;
        case "m2": productoSolicitado = this.listaProdsMedir[2].lista; break;
        case "m3": productoSolicitado = this.listaProdsMedir[3].lista; break;
        case "m4": productoSolicitado = this.listaProdsMedir[4].lista; break;
        case "m5": productoSolicitado = this.listaProdsMedir[5].lista; break;
        case "m6": productoSolicitado = this.listaProdsMedir[6].lista; break;
        case "m7": productoSolicitado = this.listaProdsMedir[7].lista; break;
        case "am1": productoSolicitado = this.listaProdsCerAmco[0].lista; break;
        case "td1": productoSolicitado = this.listaProdsCerAmco[1].lista; break;
        case "pe1": productoSolicitado = this.listaProdsCerAmco[2].lista; break;
        case "f1":
        // productoSolicitado = this.listaProdsFocus[1].lista;
        this.listaProdsFocus[1].lista.forEach(element => {
          console.log('localStorage.getItemproductoID',localStorage.getItem('productoID'));

          if (element.idCertificar==localStorage.getItem('productoID')) {
            console.log('encontroUno');
            focusAreaXAno.push(element);
          }
        });
        productoSolicitado = focusAreaXAno;



        break;
        //PULSE 3.0
        case "p1":
        this.listaProdsPulse[1].lista.forEach(element => {
          console.log('localStorage.getItemproductoID',localStorage.getItem('productoID'));

          if (element.idCertificar==localStorage.getItem('productoID')) {
            console.log('encontroUno');
            pulsecheckXAno.push(element);
          }
        });
        productoSolicitado = pulsecheckXAno;

        break;
        //PRODUCTOS   CERTIFICAR  2.0 y 3 para nuevo instituto
        case "c1": case "c2": case "c3": case "c4Plata": case "c6": productoSolicitado = data.productosCertificar; break;
      }
      console.log('productoSolicitado',productoSolicitado);

      const variablesProductos = [
        { clave: ['1','c1','c2','c3','m7','p1','f1','am1','td1','pe1','c4Plata','c6'], nombreFecha: 'fechaCertificar', nombreId: 'idCertificar' },
        { clave: ['2'], nombreFecha: 'fechaMedir', nombreId: 'idMedir' },
        { clave: ['m1','m2','m3','m4','m5','m6'], nombreFecha: 'fechaProducto', nombreId: 'idProducto' },
        { clave: ['3'], nombreFecha: 'fechaPulseCheck', nombreId: 'idPulseCheck' },
        { clave: ['4'], nombreFecha: 'fechaFocus', nombreId: 'idFocusArea' },
      ];

      const tipoVariables = variablesProductos.find(item => item.clave.includes(tipoProducto));
      const productoVigente = productoSolicitado.find(item => item[tipoVariables.nombreFecha] == parseInt(localStorage.getItem('fechaProducto')) && item[tipoVariables.nombreId] == localStorage.getItem('productoID'));
      if(productoVigente != undefined){
        this.productoVigente = productoVigente;
        this.anioProducto = parseInt(localStorage.getItem('fechaProducto'));
        if(tipoVariables.nombreFecha == 'fechaCertificar'){
          this.idPlantilla = productoVigente.idPlantilla;
        }
      }
      console.log("productoVigente:",this.productoVigente);

      // obtiene el estado de las secciones removibles
      this.getSeccionesProducto(tipoProducto,"via 1");

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getSeccionesProducto(tipoProducto:string, via:string){
    console.log("entró a getSecciones ",via," productoVigente:",this.productoVigente);

    let datos: any = {};
    let nombres = {
      forall: 'Forall',
      demog: 'Demograficos',
      adic: 'Adicionales',
      reactivos: 'Reactivos',
      abiertas: 'Abiertas'
    }
    let nombresT1 = {
      forallT1: 'Forall',
      demogT1: 'Demograficos',
      adicT1: 'Adicionales',
      reactivosT1: 'Reactivos',
      abiertasT1: 'Abiertas',
      npsT1:'NPS',
      controlT1:'Control'
    }

    let nombresT2 = {
      demogT1: 'Demograficos',
      adicT1: 'Adicionales',
      reactivosT1: 'Reactivos',
      abiertasT1: 'Abiertas',
      npsT1:'NPS',
    }
    switch(tipoProducto){
      case "1":
      datos = {productoId: localStorage.getItem('productoID')};
      this.wizardService.getSeccionesCertificar(datos).subscribe((data:backInter.getSecciones) => {
        console.log(data);
        if(data.success){
          data.secciones.forEach( (seccion) => {
            switch(seccion.nombre){
              case nombres.forall:
              this.hasForall = seccion.estatus;
              break;
              case nombres.demog:
              this.hasDemog = seccion.estatus;
              break;
              case nombres.adic:
              this.hasAdici = seccion.estatus;
              break;
              case nombres.reactivos:
              this.hasReact = seccion.estatus;
              break;
              case nombres.abiertas:
              this.hasOpen = seccion.estatus;
              break;
            }
          });
        }
        // console.log("forall:"+this.hasForall+" - demog:"+this.hasDemog+" - adic:"+this.hasAdici);
        // obtiene los status de los pasos del producto filtrado
        this.getTodosLosStatus();
      });
      break;
      case "c1": case "c2":
      datos = {productoId: localStorage.getItem('productoID')};
      this.wizardService.getSeccionesCertificar(datos).subscribe((data:backInter.getSecciones) => {
        console.log("getSeccionesCertificar:",data);

        if(data.success){
          data.secciones.forEach( (seccion) => {
            switch(seccion.nombre){
              case nombresT1.forallT1:
              this.hasForallT1 = seccion.estatus;
              break;
              case nombresT1.demogT1:
              this.hasDemogT1 = seccion.estatus;
              break;
              case nombresT1.adicT1:
              this.hasAdiciT1 = seccion.estatus;
              break;
              case nombresT1.reactivosT1:
              this.hasReactT1 = seccion.estatus;
              break;
              case nombresT1.abiertasT1:
              this.hasOpenT1 = seccion.estatus;
              break;

              case nombresT1.npsT1:
              this.hasNpsT1 = seccion.estatus;
              break;

              case nombresT1.controlT1:
              this.hasControlT1 = seccion.estatus;
              break;
            }
          });
        }
        // console.log("forall:"+this.hasForall+" - demog:"+this.hasDemog+" - adic:"+this.hasAdici);
        // obtiene los status de los pasos del producto filtrado
        this.getTodosLosStatus();
      });
      break;
      case "c3": case "m7": case "f1": case "am1": case "td1": case "pe1":case "c4Plata": case "c6":
      datos = {productoId: localStorage.getItem('productoID')};
      this.wizardService.getSeccionesCertificar(datos).subscribe((data:backInter.getSecciones) => {
        console.log("getSeccionesCertificar:",data);

        if(data.success){
          data.secciones.forEach( (seccion) => {
            this.seccionesDisponibles[seccion.nombre] = seccion.estatus;
          });
        }
        // obtiene los status de los pasos del producto filtrado
        this.getTodosLosStatus();
      });
      break;
      case "p1":

      datos = {productoId: localStorage.getItem('productoID')};
      console.log("datos",datos);

      this.wizardService.getSeccionesCertificar(datos).subscribe((data:backInter.getSecciones) => {
        console.log("getSeccionesCertificar:",data);

        if(data.success){
          data.secciones.forEach( (seccion) => {
            this.seccionesDisponibles[seccion.nombre] = seccion.estatus;
          });
        }
        // obtiene los status de los pasos del producto filtrado
        this.getTodosLosStatus();
      });
      break;
      case "2":
      this.getTodosLosStatus();
      break;
      ///funcion que destapa pasos de pulse check
      case "3":
      this.getTodosLosStatus();
      break;
      case "4":
      this.getTodosLosStatus();
      break;
      case "m6":
      datos = {productoId: localStorage.getItem('productoID')};
      this.wizardService.getSeccionesCertificar(datos).subscribe((data:backInter.getSecciones) => {
        console.log("Datos");
        console.log(data);


        if(data.success){
          this.hasNpsT1=data.secciones[0].estatus;// NPS
          this.hasReactT1 = data.secciones[1].estatus;// Reactivos
          this.hasControlT1 = data.secciones[2].estatus; // Control
          this.hasDemogT1=data.secciones[3].estatus;//Demograficos
          this.hasOpenT1 = data.secciones[4].estatus;//Abiertas
          this.hasForallT1 =data.secciones[5].estatus;;//Forall"

          console.log("nps ",this.hasNpsT1);
          console.log("reactivos", this.hasReactT1);
          console.log("control",this.hasControlT1);
          console.log("DEmo ",this.hasDemogT1);
          //console.log("adi ",this.hasDemogT1);
          console.log("abiery" ,this.hasOpenT1);
          console.log("forall ",this.hasForallT1);
        }

        this.getTodosLosStatus();
      });
      break;

      case "m1": case "m2": case "m3": case "m4": case "m5":
      datos = {productoId: localStorage.getItem('productoID')};
      this.wizardService.getSeccionesCertificar(datos).subscribe((data:backInter.getSecciones) => {
        if(data.success){
          console.log("Secciones");
          console.log(data);
          data.secciones.forEach( (seccion) => {
            switch(seccion.nombre){
              case nombresT2.demogT1:
              this.hasDemogT1 = seccion.estatus;
              break;
              case nombresT2.adicT1:
              this.hasAdiciT1 = seccion.estatus;
              break;
              case nombresT2.reactivosT1:
              this.hasReactT1 = seccion.estatus;
              break;
              case nombresT2.abiertasT1:
              this.hasOpenT1 = seccion.estatus;
              break;
              case nombresT2.npsT1:
              this.hasNpsT1=seccion.estatus;// NPS
              break;
            }
          });
        }
        this.getTodosLosStatus();
      });

      break;

    }

  }

  getTodosLosStatus(){
    //obtiene el status del paso idiomas del producto vigente
    switch(this.tipoProducto){
      case "1":
      this.wizardService.getAllStatus(localStorage.getItem('productoID')).subscribe( (data: backInter.getAllStatus) => {
        this.colocaStatusInfo(data);
      });
      break;
      case "c1": case "c2": case "c3": case "m7": case "p1": case "f1": case "am1": case "td1": case "pe1": case "c4Plata": case "c6":
      console.log('entro este caso',localStorage.getItem('productoID'));
      this.wizardService.getAllStatus(localStorage.getItem('productoID')).subscribe( (data: backInter.getAllStatus) => {
        console.log("estatus secciones :",data);
        this.colocaStatusInfo(data);
      });
      break;
      case "2":
      this.wizardService.getAllStatusMedir(localStorage.getItem('productoID')).subscribe( (data: backInter.getAllStatus) => {
        this.colocaStatusInfo(data);
      });
      break;
      case "3":
      this.wizardService.getAllStatusPulse(localStorage.getItem('productoID')).subscribe( (data: backInter.getAllStatus) => {
        console.log("entro servicio de oulse");
        this.colocaStatusInfo(data);
      });
      break;
      case "4":
      // this.actualizaFocus();
      this.wizardService.getAllStatusFocus(localStorage.getItem('encuestaID')).subscribe( (data: backInter.getAllStatus) => {
        this.colocaStatusInfo(data);
      });
      break;
      case "m1": case "m2": case "m3": case "m4": case "m5": case "m6":
      this.wizardService.getAllStatusMedir(localStorage.getItem('productoID')).subscribe( (data: backInter.getAllStatus) => {
        this.colocaStatusInfo(data);
      });
      break;
    }
  }

  colocaStatusInfo(data: backInter.getAllStatus){
    this.statusSteps = data;
    console.log("statusSteps:",this.statusSteps);

    switch (this.tipoProducto) {
      case "c1": case "c2":  //Certificar 2.0 y 3 nuevo instituto
      this.configuraStepsT1();
      break;
      case "c3": case "m7": case "p1": case "f1": case "am1": case "td1": case "pe1": case "c6":  //Certificar 3.0
      this.configuraStepsT3();
      break;
      case "c4Plata":   //Certificar 3.0
      this.configuraStepsCerPlat();
      break;
      case "m2": case "m3": case "m4": case "m5":    //nuevos medir
      this.configuraStepsMedir();
      break;
      case "m1":    //nuevos medir
      this.configuraStepsMedirMejorado();
      break;
      case "m6":    //Medir para certificar
      this.configuraStepsMedirCertificar();
      break;
      case "3":
      this.configuraStepsPulse();
      break;
      case "4":   //Focus area
      this.configuraStepsFocus(); //Chectae estos dos
      break;
      default:    //resto de productos
      this.configuraSteps();
    }
    this.actualizaStatusStepWizard();
  }


  configuraStepsPulse(){
    console.log("Pasos pulse");
    let statusActualizar = ["reactivos","forall","demograficos", "abiertas", "adicionales","colaboradores","programacion","envio","close","confirmacion"];

    let lang = this.statusSteps.estatusSecciones.idiomas;
    let react = this.statusSteps.estatusSecciones.reactivos;
    let fora = this.statusSteps.estatusSecciones.forall;
    let demo = this.statusSteps.estatusSecciones.demograficos;
    let open = this.statusSteps.estatusSecciones.abiertas;
    let adic = this.statusSteps.estatusSecciones.adicionales;
    let colb = this.statusSteps.estatusSecciones.colaboradores;
    let prog = this.statusSteps.estatusSecciones.programacion;
    let envi = this.statusSteps.estatusSecciones.envio;  //Número 7
    let cier = this.statusSteps.estatusSecciones.close;  //Número 8
    let confir = this.statusSteps.estatusSecciones.confirmacion; //Número 9

    // "completa" la sección forall de inmediato si el producto es diferente a certificar (1)
    console.log("Paso "+statusActualizar[9]);
    if(this.tipoProducto != '1'){
      fora = 3;
      this.hasOpen=false;
      this.hasAdici=false;
      this.hasDemog=false;
      this.hasReact=false;
    }

    if(lang == 3){
      if(this.hasReact){
        if(react == 1){
          this.actualizaPaso(statusActualizar[0],2)
        }
      }
      else{
        react = 3;
      }
      if(this.hasForall){
        if(fora == 1){
          this.actualizaPaso(statusActualizar[1],2);
        }
      }
      else{
        fora = 3;
      }
      if(this.hasDemog){
        if(demo == 1){
          this.actualizaPaso(statusActualizar[2],2);
        }
      }
      else{
        demo = 3;
      }
      if(this.hasOpen){
        if(open == 1){
          this.actualizaPaso(statusActualizar[3],2);
        }
      }
      else{
        open = 3;
      }
      if(this.hasAdici){
        if(adic == 1){
          this.actualizaPaso(statusActualizar[4],2);
        }
      }
      else{
        adic = 3;
      }
      if(react == 3 && fora == 3 && demo == 3 && open ==3){
        if(colb == 1){
          this.actualizaPaso(statusActualizar[5],2);
        }
      }else if(react == 3 && fora == 3 && demo == 3 && open ==3){

      }
      if(colb == 3){
        if(envi == 1){
          this.actualizaPaso(statusActualizar[7],2);
        }
      }
      if(react == 3 && fora == 3 && demo == 3 && open ==3 && adic == 3 && colb == 3){
        if(prog == 1){
          this.actualizaPaso(statusActualizar[6],2);
        }
        /*if(prog == 3 && envi == 1){
        this.actualizaPaso(statusActualizar[7],2);
      }
      if(prog == 3 && envi == 3 && cier == 1){
      this.actualizaPaso(statusActualizar[8],2);
    }*/
  }

  if(react == 3 && fora == 3 && demo == 3 && open ==3 && adic == 3 && colb == 3){

    if(prog == 3 && envi == 3){
      if (confir==1) {
        this.actualizaPaso(statusActualizar[9],2);

      }

      if(confir==3){
        if(cier==1) {
          this.actualizaPaso(statusActualizar[8],2); //Cierre
        }
      }else if(confir==2){
        if(cier==2) {
          this.actualizaPaso(statusActualizar[8],1); //Cierre
        }
      }
    }else{
      if(confir != 1){
        this.actualizaPaso(statusActualizar[9],1); //confi
      }
      if (cier==2) {
        this.actualizaPaso(statusActualizar[8],1);//Cierre
      }
    }

  }else{
    if(confir != 1){
      this.actualizaPaso(statusActualizar[9],1); //confir
    }
  }
}

}

configuraStepsMedir(){
  console.log("STEPS");
  console.log("Demograficos ",this.hasDemogT1);
  let statusActualizar = ["reactivos","demograficos", "abiertas", "adicionales","colaboradores","programacion","envio","close","nps"];
  let lang = this.statusSteps.estatusSecciones.idiomas;
  let react = this.statusSteps.estatusSecciones.reactivos;
  let demo = this.statusSteps.estatusSecciones.demograficos;
  let open = this.statusSteps.estatusSecciones.abiertas;
  let adic = this.statusSteps.estatusSecciones.adicionales;
  let colb = this.statusSteps.estatusSecciones.colaboradores;
  let prog = this.statusSteps.estatusSecciones.programacion;
  let envi = this.statusSteps.estatusSecciones.envio;
  let cier = this.statusSteps.estatusSecciones.close;
  let nps = this.statusSteps.estatusSecciones.nps;
  console.log("NPS NEGRO");
  console.log(nps);
  console.log(this.hasNpsT1);
  if(this.tipoProducto != 'm1' && this.tipoProducto != 'm6'){
    console.log("Diferentes de nps");
    nps=3;
  }
  if(lang == 3){
    if(this.hasReactT1){
      if(react == 1){
        this.actualizaPaso(statusActualizar[0],2)
      }
    }
    else{
      react = 3;
    }
    if(this.hasDemogT1){
      if(demo == 1){
        this.actualizaPaso(statusActualizar[1],2);
      }
    }
    else{
      demo = 3;
    }
    if(this.hasOpenT1){
      if(open == 1){
        this.actualizaPaso(statusActualizar[2],2);
      }
    }
    else{
      open = 3;
    }
    if(this.hasAdiciT1){
      if(adic == 1){
        this.actualizaPaso(statusActualizar[3],2);
      }
    }
    else{
      adic = 3;
    }
    if(this.hasNpsT1){
      if(nps == 1){
        this.actualizaPaso(statusActualizar[8],2);
      }
    }else{
      nps = 3;
    }
    if(demo == 3){
      if(colb == 1){
        this.actualizaPaso(statusActualizar[4],2);
      }
    }
    // if(react == 3  && demo == 3 && open ==3 && adic == 3 && colb == 3){
    console.log("PARTE BROTHAR");
    console.log(demo);
    console.log(colb);
    console.log(react);
    console.log(open);
    console.log(nps);
    if( demo == 3 && colb == 3 && react == 3 && open == 3 && nps == 3 ){
      if(prog == 1){
        this.actualizaPaso(statusActualizar[5],2);
      }
      if(prog == 3 && envi == 1){
        this.actualizaPaso(statusActualizar[6],2);
      }
      if(prog == 3 && envi == 3 && cier == 1){
        this.actualizaPaso(statusActualizar[7],2);
      }
    }

    else if(demo == 2 || colb == 2 || react == 2 || open == 2 || nps==2){
      if(prog == 2 || prog == 3){
        this.actualizaPaso(statusActualizar[5],1);
        if(envi == 2 || envi == 3){
          this.actualizaPaso(statusActualizar[6],1);
        }
        if(cier == 2){
          this.actualizaPaso(statusActualizar[7],1);
        }
      }
    }
  }

}

configuraStepsMedirMejorado(){
  let statusActualizar = ["reactivos","demograficos", "abiertas", "adicionales","colaboradores","programacion","envio","close","nps","confirmacion"];
  let lang = this.statusSteps.estatusSecciones.idiomas;
  let react = this.statusSteps.estatusSecciones.reactivos;
  let demo = this.statusSteps.estatusSecciones.demograficos;
  let open = this.statusSteps.estatusSecciones.abiertas;
  let adic = this.statusSteps.estatusSecciones.adicionales;
  let colb = this.statusSteps.estatusSecciones.colaboradores;
  let prog = this.statusSteps.estatusSecciones.programacion;
  let envi = this.statusSteps.estatusSecciones.envio;
  let cier = this.statusSteps.estatusSecciones.close;
  let nps = this.statusSteps.estatusSecciones.nps;
  let confir = this.statusSteps.estatusSecciones.confirmacion; //Número 9
  console.log("NPS NEGRO");
  console.log(nps);
  console.log(this.hasNpsT1);
  if(this.tipoProducto != 'm1' && this.tipoProducto != 'm6'){
    console.log("Diferentes de nps");
    nps=3;
  }
  if(lang == 3){
    if(this.hasReactT1){
      if(react == 1){
        this.actualizaPaso(statusActualizar[0],2)
      }
    }
    else{
      react = 3;
    }
    if(this.hasDemogT1){
      if(demo == 1){
        this.actualizaPaso(statusActualizar[1],2);
      }
    }
    else{
      demo = 3;
    }
    if(this.hasOpenT1){
      if(open == 1){
        this.actualizaPaso(statusActualizar[2],2);
      }
    }
    else{
      open = 3;
    }
    if(this.hasAdiciT1){
      if(adic == 1){
        this.actualizaPaso(statusActualizar[3],2);
      }
    }
    else{
      adic = 3;
    }
    if(this.hasNpsT1){
      if(nps == 1){
        this.actualizaPaso(statusActualizar[8],2);
      }
    }else{
      nps = 3;
    }

    if(demo == 3 && react == 3 && open == 3 && nps == 3){
      if(colb == 1){
        this.actualizaPaso(statusActualizar[4],2);
      }
    }
    // if(react == 3  && demo == 3 && open ==3 && adic == 3 && colb == 3){
    console.log("PARTE BROTHAR");
    console.log(demo);
    console.log(colb);
    console.log(react);
    console.log(open);
    console.log(nps);
    console.log(confir);
    if( demo == 3 && colb == 3 && react == 3 && open == 3 && nps == 3 ){
      if(prog == 1){
        this.actualizaPaso(statusActualizar[5],2);
      }

      if(prog == 3 && envi == 1){
        this.actualizaPaso(statusActualizar[6],2);
      }

      if(prog == 3 && envi == 3){
        if (confir==1) {
          this.actualizaPaso(statusActualizar[9],2);
        }

        if(confir==3){
          console.log('entro cuando confirmar esta completo',confir);
          if(cier==1) {
            console.log('entro abrir seccion seguimiento',cier);
            this.actualizaPaso(statusActualizar[7],2);
          }
        }else if(confir==2){
          console.log('entro cuando confirmar esta abierto',confir);
          if(cier==2) {
            console.log('entro cerrar seccion seguimiento',cier);
            this.actualizaPaso(statusActualizar[7],1);
          }
        }
      }else{
        if(confir != 1){
          this.actualizaPaso(statusActualizar[9],1);
        }
        if (cier==2) {
          this.actualizaPaso(statusActualizar[7],1);
        }
      }
    }else{
      if(confir != 1){
        this.actualizaPaso(statusActualizar[9],1);
      }
    }

    // if(demo == 2 || colb == 2 || react == 2 || open == 2 || nps==2){
    //   if(prog == 2 || prog == 3){
    //     this.actualizaPaso(statusActualizar[5],1);
    //     if(envi == 2 || envi == 3){
    //       this.actualizaPaso(statusActualizar[6],1);
    //     }
    //     if(cier == 2){
    //       this.actualizaPaso(statusActualizar[7],1);
    //     }
    //   }
    // }
  }

}

configuraStepsMedirCertificar(){
  console.log("Configurar pasos medir");
  console.log(this.statusSteps);
  console.log(this.hasForall);
  console.log(this.hasForallT1);
  let statusActualizar = ["reactivos","demograficos", "abiertas", "adicionales","colaboradores","programacion","envio","close","forall","nps"];
  let lang = this.statusSteps.estatusSecciones.idiomas;
  let react = this.statusSteps.estatusSecciones.reactivos;
  let fora = this.statusSteps.estatusSecciones.forall;
  let nps = this.statusSteps.estatusSecciones.nps;
  let demo = this.statusSteps.estatusSecciones.demograficos;
  let open = this.statusSteps.estatusSecciones.abiertas;
  let adic = this.statusSteps.estatusSecciones.adicionales;
  let colb = this.statusSteps.estatusSecciones.colaboradores;
  let prog = this.statusSteps.estatusSecciones.programacion;
  let envi = this.statusSteps.estatusSecciones.envio;
  let cier = this.statusSteps.estatusSecciones.close;
  if(lang == 3){
    if(this.hasReactT1){
      if(react == 1){
        this.actualizaPaso(statusActualizar[0],2);
      }
    }
    else{
      react = 3;
    }

    if(this.hasForallT1){
      if(this.statusSteps.estatusSecciones.forall== 1){
        this.actualizaPaso(statusActualizar[8],2);
      }
    }
    else{
      fora = 3;
    }

    if(this.statusSteps.estatusSecciones.nps== 1){
      this.actualizaPaso(statusActualizar[9],2);

    }
    else{
      nps=3;
    }

    if(this.hasDemogT1){
      if(demo == 1){
        this.actualizaPaso(statusActualizar[1],2);
      }
    }
    else{
      demo = 3;
    }
    if(this.hasOpenT1){
      if(open == 1){
        this.actualizaPaso(statusActualizar[2],2);
      }
    }
    else{
      open = 3;
    }
    if(this.hasAdiciT1){
      if(adic == 1){
        this.actualizaPaso(statusActualizar[3],2);
      }
    }
    else{
      adic = 3;
    }
    if(demo == 3){
      if(colb == 1){
        this.actualizaPaso(statusActualizar[4],2);
      }
    }
    // if(react == 3  && demo == 3 && open ==3 && adic == 3 && colb == 3){
    if( demo == 3 && colb == 3 && react == 3 && open == 3 && fora ==3 && nps==3){
      if(prog == 1){
        this.actualizaPaso(statusActualizar[5],2);
      }
      if(prog == 3 && envi == 1){
        this.actualizaPaso(statusActualizar[6],2);
      }
      if(prog == 3 && envi == 3 && cier == 1){
        this.actualizaPaso(statusActualizar[7],2);
      }
    }

    else if(demo == 2 || colb == 2 || react == 2 || open == 2 || fora ==2 || nps==2){
      if(prog == 2 || prog == 3){
        this.actualizaPaso(statusActualizar[5],1);
        if(envi == 2 || envi == 3){
          this.actualizaPaso(statusActualizar[6],1);
        }
        if(cier == 2){
          this.actualizaPaso(statusActualizar[7],1);
        }
      }
    }
  }

}

configuraSteps(){
  let statusActualizar = ["reactivos","forall","demograficos", "abiertas", "adicionales","colaboradores","programacion","envio","close"];

  let lang = this.statusSteps.estatusSecciones.idiomas;
  let react = this.statusSteps.estatusSecciones.reactivos;
  let fora = this.statusSteps.estatusSecciones.forall;
  let demo = this.statusSteps.estatusSecciones.demograficos;
  let open = this.statusSteps.estatusSecciones.abiertas;
  let adic = this.statusSteps.estatusSecciones.adicionales;
  let colb = this.statusSteps.estatusSecciones.colaboradores;
  let prog = this.statusSteps.estatusSecciones.programacion;
  let envi = this.statusSteps.estatusSecciones.envio;
  let cier = this.statusSteps.estatusSecciones.close;

  // "completa" la sección forall de inmediato si el producto es diferente a certificar (1)
  if(this.tipoProducto != '1'){
    fora = 3;
    this.hasOpen=false;
    this.hasAdici=false;
    this.hasDemog=false;
    this.hasReact=false;
  }

  if(lang == 3){
    if(this.hasReact){
      if(react == 1){
        this.actualizaPaso(statusActualizar[0],2)
      }
    }
    else{
      react = 3;
    }
    if(this.hasForall){
      if(fora == 1){
        this.actualizaPaso(statusActualizar[1],2);
      }
    }
    else{
      fora = 3;
    }
    if(this.hasDemog){
      if(demo == 1){
        this.actualizaPaso(statusActualizar[2],2);
      }
    }
    else{
      demo = 3;
    }
    if(this.hasOpen){
      if(open == 1){
        this.actualizaPaso(statusActualizar[3],2);
      }
    }
    else{
      open = 3;
    }
    if(this.hasAdici){
      if(adic == 1){
        this.actualizaPaso(statusActualizar[4],2);
      }
    }
    else{
      adic = 3;
    }
    if(react == 3 && fora == 3 && demo == 3 && open ==3){
      if(colb == 1){
        this.actualizaPaso(statusActualizar[5],2);
      }
    }
    if(react == 3 && fora == 3 && demo == 3 && open ==3 && adic == 3 && colb == 3){
      if(prog == 1){
        this.actualizaPaso(statusActualizar[6],2);
      }
      if(prog == 3 && envi == 1){
        this.actualizaPaso(statusActualizar[7],2);
      }
      if(prog == 3 && envi == 3 && cier == 1){
        this.actualizaPaso(statusActualizar[8],2);
      }
    }
  }

}

configuraStepsT1(){

  let statusActualizar = ["nps","reactivos","forall","control","demograficos", "abiertas", "adicionales","encuesta","colaboradores","programacion","envio","confirmacion","close"];
  let lang = this.statusSteps.estatusSecciones.idiomas;
  let nps = this.statusSteps.estatusSecciones.nps;
  let react = this.statusSteps.estatusSecciones.reactivos;
  let fora = this.statusSteps.estatusSecciones.forall;
  let control = this.statusSteps.estatusSecciones.control;
  let demo = this.statusSteps.estatusSecciones.demograficos;
  let open = this.statusSteps.estatusSecciones.abiertas;
  let adic = this.statusSteps.estatusSecciones.adicionales;
  let encu = this.statusSteps.estatusSecciones.encuesta;
  let colb = this.statusSteps.estatusSecciones.colaboradores;
  let prog = this.statusSteps.estatusSecciones.programacion;
  let envi = this.statusSteps.estatusSecciones.envio;
  let confir = this.statusSteps.estatusSecciones.confirmacion;
  let cier = this.statusSteps.estatusSecciones.close;

  if(this.instituto=="HK"){
    this.hasNpsT1=false;
  }

  if(this.instituto=="TK" || this.idPlantilla=="5e9605e0b473cb6d3ec67f3c" || this.instituto=="IZZI"){
    this.hasControlT1=false;
  }

  if(lang == 3){
    if(this.hasNpsT1){
      if(nps == 1){
        this.actualizaPaso(statusActualizar[0],2)
      }
    }
    else{
      nps = 3;
    }

    if(this.hasReactT1){
      if(react == 1){
        this.actualizaPaso(statusActualizar[1],2)
      }
    }
    else{
      react = 3;
    }
    if(this.hasForallT1){
      if(fora == 1){
        this.actualizaPaso(statusActualizar[2],2);
      }
    }
    else{
      fora = 3;
    }
    if(this.hasControlT1){
      if(control == 1){
        this.actualizaPaso(statusActualizar[3],2)
      }
    }
    else{
      control = 3;
    }
    if(this.hasDemogT1){
      if(demo == 1){
        this.actualizaPaso(statusActualizar[4],2);
      }
    }
    else{
      demo = 3;
    }
    if(this.hasOpenT1){
      if(open == 1){
        this.actualizaPaso(statusActualizar[5],2);
      }
    }
    else{
      open = 3;
    }
    if(this.hasAdiciT1){
      if(adic == 1){
        this.actualizaPaso(statusActualizar[6],2);
      }
    }
    else{
      adic = 3;
    }

    if(nps == 3 && react == 3 && fora == 3 && control == 3 && demo == 3 && open==3 && adic==3){
      if(encu == 1){
        this.actualizaPaso(statusActualizar[7],2);
      }
    }
    else if(nps == 2 || react == 2 || fora == 2 || control == 2 || demo == 2 || open==2 || adic==2){
      if(encu == 2 || encu == 3){
        this.actualizaPaso(statusActualizar[7],1);
        if(colb == 2 || colb == 3){
          this.actualizaPaso(statusActualizar[8],1);
        }
        if(envi == 2 || envi == 3){
          this.actualizaPaso(statusActualizar[10],1);
        }
        if(prog == 2 || prog == 3){
          this.actualizaPaso(statusActualizar[9],1);
        }
        if(cier == 2){
          if(confir != 1){
            this.actualizaPaso(statusActualizar[11],1);
          }
        }
      }
    }
    if(encu == 3){
      if(colb == 1){
        this.actualizaPaso(statusActualizar[8],2);
      }
      if(envi == 1){
        this.actualizaPaso(statusActualizar[10],2);
      }
      if(prog == 1){
        this.actualizaPaso(statusActualizar[9],2);
      }
    }
    if(encu == 2){ // Evita que se marquen los demás pasos
      if(colb == 2){
        this.actualizaPaso(statusActualizar[8],1);
      }
      if(envi == 2){
        this.actualizaPaso(statusActualizar[10],1);
      }
      if(prog == 2){
        this.actualizaPaso(statusActualizar[9],1);
      }
    }

    if(nps == 3 && react == 3 && fora == 3 && control == 3 && demo == 3 && open ==3 && adic == 3 && encu == 3 && colb == 3){
      if(prog == 3 && envi == 3){
        if (confir==1) {
          this.actualizaPaso(statusActualizar[11],2);

        }

        if(confir==3){
          if(cier==1) {
            this.actualizaPaso(statusActualizar[12],2);
          }
        }else if(confir==2){
          if(cier==2) {
            this.actualizaPaso(statusActualizar[12],1);
          }
        }
      }else{
        if(confir != 1){
          this.actualizaPaso(statusActualizar[11],1);
        }
        if (cier==2) {
          this.actualizaPaso(statusActualizar[12],1);
        }
      }

    }else{
      if(confir != 1){
        this.actualizaPaso(statusActualizar[11],1);
      }
    }



  }

}

configuraStepsT3_back(){

  let statusActualizar = ["nps","reactivos","forall","control","demograficos", "abiertas", "adicionales","encuesta","colaboradores","programacion","envio","confirmacion","close","template"];
  let lang = this.statusSteps.estatusSecciones.idiomas;
  let nps = this.statusSteps.estatusSecciones.nps;
  let react = this.statusSteps.estatusSecciones.reactivos;
  let fora = this.statusSteps.estatusSecciones.forall;
  let control = this.statusSteps.estatusSecciones.control;
  let demo = this.statusSteps.estatusSecciones.demograficos;
  let open = this.statusSteps.estatusSecciones.abiertas;
  let adic = this.statusSteps.estatusSecciones.adicionales;
  let encu = this.statusSteps.estatusSecciones.encuesta;
  let colb = this.statusSteps.estatusSecciones.colaboradores;
  let prog = this.statusSteps.estatusSecciones.programacion;
  let envi = this.statusSteps.estatusSecciones.envio;
  let confir = this.statusSteps.estatusSecciones.confirmacion;
  let cier = this.statusSteps.estatusSecciones.close;
  let temp = this.statusSteps.estatusSecciones.template;
  //   console.log(temp);
  // console.log("entro ala funcion de 3:",this.statusSteps);
  console.log("entro ala funcion de encu:",encu);


  if(this.instituto=="HK"){
    this.seccionesDisponibles.NPS = false;
  }
  if(this.idPlantilla=="5e9605e0b473cb6d3ec67f3c"||this.instituto=="IZZI"){
    this.seccionesDisponibles.Control = false;
  }

  if(lang == 3){
    if(temp==1) {
      this.actualizaPaso(statusActualizar[13],2)
    }else if(temp==2) {
      if(localStorage.getItem("userBypass")) {
        console.log("no hace nada ");

      }else{
        this.actualizaPaso(statusActualizar[13],3)
        temp=3;
      }

    }else if(temp==3) {
      if(this.seccionesDisponibles.NPS){
        if(nps == 1){
          this.actualizaPaso(statusActualizar[0],2)
        }
      }
      else{
        nps = 3;
      }

      if(this.seccionesDisponibles.Reactivos){
        if(react == 1){
          this.actualizaPaso(statusActualizar[1],2)
        }
      }
      else{
        react = 3;
      }
      if(this.seccionesDisponibles.Forall){
        if(fora == 1){
          this.actualizaPaso(statusActualizar[2],2);
        }
      }
      else{
        fora = 3;
      }
      if(this.seccionesDisponibles.Control){
        if(control == 1){
          this.actualizaPaso(statusActualizar[3],2)
        }
      }
      else{
        control = 3;
      }
      if(this.seccionesDisponibles.Demograficos){
        if(demo == 1){
          this.actualizaPaso(statusActualizar[4],2);
        }
      }
      else{
        demo = 3;
      }
      if(this.seccionesDisponibles.Abiertas){
        if(open == 1){
          this.actualizaPaso(statusActualizar[5],2);
        }
      }
      else{
        open = 3;
      }
      if(this.seccionesDisponibles.Adicionales){
        if(adic == 1){
          this.actualizaPaso(statusActualizar[6],2);
        }
      }
      else{
        adic = 3;
      }
console.log('nps',nps);
console.log('react',react);
console.log('fora',fora);
console.log('control',control);
console.log('demo',demo);
console.log('open',open);
console.log('adic',adic);

      if(nps == 3 && react == 3 && fora == 3 && control == 3 && demo == 3 && open==3 && adic==3){
        console.log('entro seccion completas');
        console.log(encu);
        if(encu == 1){
          console.log('abrur  encuesta');
          this.actualizaPaso(statusActualizar[7],2);
        }
      }else if(nps == 2 || react == 2 || fora == 2 || control == 2 || demo == 2 || open==2 || adic==2){
        if(encu == 2 || encu == 3){
          this.actualizaPaso(statusActualizar[7],1);
          if(colb == 2 || colb == 3){
            this.actualizaPaso(statusActualizar[8],1);
          }
          if(envi == 2 || envi == 3){
            this.actualizaPaso(statusActualizar[10],1);
          }
          if(prog == 2 || prog == 3){
            this.actualizaPaso(statusActualizar[9],1);
          }
          if(cier == 2){
            if(confir != 1){
              this.actualizaPaso(statusActualizar[11],1);
            }
          }
        }
      }
      console.log(encu);
      if(encu == 3){
        if(colb == 1){
          this.actualizaPaso(statusActualizar[8],2);
        }
        if(envi == 1){
          this.actualizaPaso(statusActualizar[10],2);
        }
        if(prog == 1){
          this.actualizaPaso(statusActualizar[9],2);
        }
      }
      console.log(encu);
      if(encu == 2){ // Evita que se marquen los demás pasos
        if(colb == 2){
          this.actualizaPaso(statusActualizar[8],1);
        }
        if(envi == 2){
          this.actualizaPaso(statusActualizar[10],1);
        }
        if(prog == 2){
          this.actualizaPaso(statusActualizar[9],1);
        }
      }

      if(nps == 3 && react == 3 && fora == 3 && control == 3 && demo == 3 && open ==3 && adic == 3 && encu == 3 && colb == 3){
        if(prog == 3 && envi == 3){
          if (confir==1) {
            this.actualizaPaso(statusActualizar[11],2);

          }

          if(confir==3){
            if(cier==1) {
              this.actualizaPaso(statusActualizar[12],2);
            }
          }else if(confir==2){
            if(cier==2) {
              this.actualizaPaso(statusActualizar[12],1);
            }
          }
        }else{
          if(confir != 1){
            this.actualizaPaso(statusActualizar[11],1);
          }
          if (cier==2) {
            this.actualizaPaso(statusActualizar[12],1);
          }
        }

      }else{
        if(confir != 1){
          this.actualizaPaso(statusActualizar[11],1);
        }
      }
    }
  }
  console.log(encu);
}

configuraStepsT3(){
  let refSteps = this.statusSteps.estatusSecciones;
  const seccionesPreviasEncuesta = ['nps', 'reactivos', 'forall', 'control', 'demograficos', 'abiertas', 'adicionales'];
  const seccionesPostEncuesta = ['encuesta','colaboradores','programacion','envio'];
  const seccionCompleta = (seccion) => refSteps[seccion] == 3;
  const seccionAbierta = (seccion) => refSteps[seccion] == 2;

  /// CONDICIONES ESPECIFICAS DE ACTIVACION
  if(this.instituto=="HK"){
    this.seccionesDisponibles.NPS = false;
  }
  if(this.idPlantilla=="5e9605e0b473cb6d3ec67f3c" || this.instituto=="IZZI"){
    this.seccionesDisponibles.Control = false;
  }

  // ACTIVACION DE PASOS SEGUN ESCENARIO NORMAL
  if(refSteps.idiomas == 3){
    if(refSteps.voice == 1){
      if(this.mostrarPasoVoice == true){
        this.actualizaPaso('voice', 2);
      } else{
        this.actualizaPaso('voice', 3);
      }
    } else if(refSteps.voice == 2){ //DESACTIVAR PASOS POSTERIORES
      if (this.mostrarPasoVoice == true) {
        if(refSteps.template != 1) this.actualizaPaso('template', 1);
        if(refSteps.nps != 1) this.actualizaPaso('nps', 1);
        if(refSteps.reactivos != 1) this.actualizaPaso('reactivos', 1);
        if(refSteps.forall != 1) this.actualizaPaso('forall', 1);
        if(refSteps.control != 1) this.actualizaPaso('control', 1);
        if(refSteps.demograficos != 1) this.actualizaPaso('demograficos', 1);
        if(refSteps.abiertas != 1) this.actualizaPaso('abiertas', 1);
        if(refSteps.adicionales != 1) this.actualizaPaso('adicionales', 1);
        if(refSteps.encuesta != 1) this.actualizaPaso('encuesta', 1);
        if(refSteps.colaboradores != 1) this.actualizaPaso('colaboradores', 1);
        if(refSteps.programacion != 1) this.actualizaPaso('programacion', 1);
        if(refSteps.envio != 1) this.actualizaPaso('envio', 1);
        if(refSteps.confirmacion != 1) this.actualizaPaso('confirmacion', 1);
        if(refSteps.close != 1) this.actualizaPaso('close', 1);
      }
    } else if(refSteps.voice == 3){
      if(refSteps.template == 1){
        this.actualizaPaso('template', 2);
      } else if(refSteps.template == 2) {
        if(localStorage.getItem("userBypass") == undefined) {
          this.actualizaPaso('template', 3);
          refSteps.template = 3;
        }
      } else if(refSteps.template == 3){
        /// PASO NPS
        if(this.seccionesDisponibles.NPS){
          if(refSteps.nps == 1){
            this.actualizaPaso('nps', 2);
          }
        } else { refSteps.nps = 3; }

        /// PASO REACTIVOS
        if(this.seccionesDisponibles.Reactivos){
          if(refSteps.reactivos == 1){
            this.actualizaPaso('reactivos', 2);
          }
        } else { refSteps.reactivos = 3; }

        /// PASO FORALL
        if(this.seccionesDisponibles.Forall){
          if(refSteps.forall == 1){
            this.actualizaPaso('forall', 2);
          }
        } else { refSteps.forall = 3; }

        /// PASO CONTROL
        if(this.seccionesDisponibles.Control){
          if(refSteps.control == 1){
            this.actualizaPaso('control', 2);
          }
        } else { refSteps.control = 3; }

        /// PASO DEMOGRAFICOS
        if(this.seccionesDisponibles.Demograficos){
          if(refSteps.demograficos == 1){
            this.actualizaPaso('demograficos', 2);
          }
        } else { refSteps.demograficos = 3; }

        /// PASO ABIERTAS
        if(this.seccionesDisponibles.Abiertas){
          if(refSteps.abiertas == 1){
            this.actualizaPaso('abiertas', 2);
          }
        } else { refSteps.abiertas = 3; }

        /// PASO ADICIONALES
        if(this.seccionesDisponibles.Adicionales){
          if(refSteps.adicionales == 1){
            this.actualizaPaso('adicionales', 2);
          }
        } else { refSteps.adicionales = 3; }

        if(seccionesPreviasEncuesta.every(seccionCompleta)){
          switch (refSteps.encuesta) {
            case 1: this.actualizaPaso('encuesta', 2); break;
            case 2:
            if(refSteps.colaboradores != 1){
              this.actualizaPaso('colaboradores', 1);
            }
            if(refSteps.programacion != 1){
              this.actualizaPaso('programacion', 1);
            }
            if(refSteps.envio != 1){
              this.actualizaPaso('envio', 1);
            }
            break;
            case 3:
            if(refSteps.colaboradores == 1){
              this.actualizaPaso('colaboradores', 2);
            }
            if(refSteps.programacion == 1){
              this.actualizaPaso('programacion', 2);
            }
            if(refSteps.envio == 1){
              this.actualizaPaso('envio', 2);
            }
            break;
          }
          if(seccionesPostEncuesta.every(seccionCompleta)){
            switch (refSteps.confirmacion) {
              case 1: this.actualizaPaso('confirmacion', 2); break;
              case 2:
                if(refSteps.close != 1) this.actualizaPaso('close', 1);
              break;
              case 3:
                if(refSteps.close == 1) this.actualizaPaso('close', 2);
              break;
            }
          } else{
            if(refSteps.confirmacion != 1) this.actualizaPaso('confirmacion', 1);
            if(refSteps.close != 1) this.actualizaPaso('close', 1);
          }
        } else if(seccionesPreviasEncuesta.some(seccionAbierta)){
          if(refSteps.encuesta != 1) this.actualizaPaso('encuesta', 1);
          if(refSteps.colaboradores != 1) this.actualizaPaso('colaboradores', 1);
          if(refSteps.programacion != 1) this.actualizaPaso('programacion', 1);
          if(refSteps.envio != 1) this.actualizaPaso('envio', 1);
          if(refSteps.confirmacion != 1) this.actualizaPaso('confirmacion', 1);
          if(refSteps.close != 1) this.actualizaPaso('close', 1);
        }
      }
    }
  }
}

configuraStepsCerPlat(){
  let refSteps = this.statusSteps.estatusSecciones;
  const seccionesPreviasEncuesta = ['nps', 'reactivos', 'forall', 'control', 'demograficos', 'abiertas', 'adicionales'];
  const seccionesPostEncuesta = ['encuesta','colaboradores','programacion','envio'];
  const seccionCompleta = (seccion) => refSteps[seccion] == 3;
  const seccionAbierta = (seccion) => refSteps[seccion] == 2;
  //
  // /// CONDICIONES ESPECIFICAS DE ACTIVACION
  // if(this.instituto=="HK"){
  //   this.seccionesDisponibles.NPS = false;
  // }
  // if(this.idPlantilla=="5e9605e0b473cb6d3ec67f3c" || this.instituto=="IZZI"){
  //   this.seccionesDisponibles.Control = false;
  // }
  //
  // // ACTIVACION DE PASOS SEGUN ESCENARIO NORMAL
  // if(refSteps.idiomas == 3){
  //   if(refSteps.voice == 1){
  //     if(this.mostrarPasoVoice == true){
  //       this.actualizaPaso('voice', 2);
  //     } else{
  //       this.actualizaPaso('voice', 3);
  //     }
  //   } else if(refSteps.voice == 2){ //DESACTIVAR PASOS POSTERIORES
  //     if (this.mostrarPasoVoice == true) {
  //       if(refSteps.template != 1) this.actualizaPaso('template', 1);
  //       if(refSteps.nps != 1) this.actualizaPaso('nps', 1);
  //       if(refSteps.reactivos != 1) this.actualizaPaso('reactivos', 1);
  //       if(refSteps.forall != 1) this.actualizaPaso('forall', 1);
  //       if(refSteps.control != 1) this.actualizaPaso('control', 1);
  //       if(refSteps.demograficos != 1) this.actualizaPaso('demograficos', 1);
  //       if(refSteps.abiertas != 1) this.actualizaPaso('abiertas', 1);
  //       if(refSteps.adicionales != 1) this.actualizaPaso('adicionales', 1);
  //       if(refSteps.encuesta != 1) this.actualizaPaso('encuesta', 1);
  //       if(refSteps.colaboradores != 1) this.actualizaPaso('colaboradores', 1);
  //       if(refSteps.programacion != 1) this.actualizaPaso('programacion', 1);
  //       if(refSteps.envio != 1) this.actualizaPaso('envio', 1);
  //       if(refSteps.confirmacion != 1) this.actualizaPaso('confirmacion', 1);
  //       if(refSteps.close != 1) this.actualizaPaso('close', 1);
  //     }
  //   } else if(refSteps.voice == 3){
  //     if(refSteps.template == 1){
  //       this.actualizaPaso('template', 2);
  //     } else if(refSteps.template == 2) {
  //       if(localStorage.getItem("userBypass") == undefined) {
  //         this.actualizaPaso('template', 3);
  //         refSteps.template = 3;
  //       }
  //     } else if(refSteps.template == 3){
  //       /// PASO NPS
  //       if(this.seccionesDisponibles.NPS){
  //         if(refSteps.nps == 1){
  //           this.actualizaPaso('nps', 2);
  //         }
  //       } else { refSteps.nps = 3; }
  //
  //       /// PASO REACTIVOS
  //       if(this.seccionesDisponibles.Reactivos){
  //         if(refSteps.reactivos == 1){
  //           this.actualizaPaso('reactivos', 2);
  //         }
  //       } else { refSteps.reactivos = 3; }
  //
  //       /// PASO FORALL
  //       if(this.seccionesDisponibles.Forall){
  //         if(refSteps.forall == 1){
  //           this.actualizaPaso('forall', 2);
  //         }
  //       } else { refSteps.forall = 3; }
  //
  //       /// PASO CONTROL
  //       if(this.seccionesDisponibles.Control){
  //         if(refSteps.control == 1){
  //           this.actualizaPaso('control', 2);
  //         }
  //       } else { refSteps.control = 3; }
  //
  //       /// PASO DEMOGRAFICOS
  //       if(this.seccionesDisponibles.Demograficos){
  //         if(refSteps.demograficos == 1){
  //           this.actualizaPaso('demograficos', 2);
  //         }
  //       } else { refSteps.demograficos = 3; }
  //
  //       /// PASO ABIERTAS
  //       if(this.seccionesDisponibles.Abiertas){
  //         if(refSteps.abiertas == 1){
  //           this.actualizaPaso('abiertas', 2);
  //         }
  //       } else { refSteps.abiertas = 3; }
  //
  //       /// PASO ADICIONALES
  //       if(this.seccionesDisponibles.Adicionales){
  //         if(refSteps.adicionales == 1){
  //           this.actualizaPaso('adicionales', 2);
  //         }
  //       } else { refSteps.adicionales = 3; }
  //
  //       if(seccionesPreviasEncuesta.every(seccionCompleta)){
  //         switch (refSteps.encuesta) {
  //           case 1: this.actualizaPaso('encuesta', 2); break;
  //           case 2:
  //           if(refSteps.colaboradores != 1){
  //             this.actualizaPaso('colaboradores', 1);
  //           }
  //           if(refSteps.programacion != 1){
  //             this.actualizaPaso('programacion', 1);
  //           }
  //           if(refSteps.envio != 1){
  //             this.actualizaPaso('envio', 1);
  //           }
  //           break;
  //           case 3:
  //           if(refSteps.colaboradores == 1){
  //             this.actualizaPaso('colaboradores', 2);
  //           }
  //           if(refSteps.programacion == 1){
  //             this.actualizaPaso('programacion', 2);
  //           }
  //           if(refSteps.envio == 1){
  //             this.actualizaPaso('envio', 2);
  //           }
  //           break;
  //         }
  //         if(seccionesPostEncuesta.every(seccionCompleta)){
  //           switch (refSteps.confirmacion) {
  //             case 1: this.actualizaPaso('confirmacion', 2); break;
  //             case 2:
  //               if(refSteps.close != 1) this.actualizaPaso('close', 1);
  //             break;
  //             case 3:
  //               if(refSteps.close == 1) this.actualizaPaso('close', 2);
  //             break;
  //           }
  //         } else{
  //           if(refSteps.confirmacion != 1) this.actualizaPaso('confirmacion', 1);
  //           if(refSteps.close != 1) this.actualizaPaso('close', 1);
  //         }
  //       } else if(seccionesPreviasEncuesta.some(seccionAbierta)){
  //         if(refSteps.encuesta != 1) this.actualizaPaso('encuesta', 1);
  //         if(refSteps.colaboradores != 1) this.actualizaPaso('colaboradores', 1);
  //         if(refSteps.programacion != 1) this.actualizaPaso('programacion', 1);
  //         if(refSteps.envio != 1) this.actualizaPaso('envio', 1);
  //         if(refSteps.confirmacion != 1) this.actualizaPaso('confirmacion', 1);
  //         if(refSteps.close != 1) this.actualizaPaso('close', 1);
  //       }
  //     }
  //   }
  // }
  if(refSteps.encuesta == 1){
    console.log('entro aqui sdhsadasd;a');
    this.actualizaPaso('encuesta', 2);
  }else if (refSteps.encuesta == 3) {
    if(refSteps.colaboradores == 1){
               this.actualizaPaso('colaboradores', 2);
             }
             if(refSteps.programacion == 1){
               this.actualizaPaso('programacion', 2);
             }
             if(refSteps.envio == 1){
               this.actualizaPaso('envio', 2);
             }


  }else{
    if(refSteps.colaboradores != 1){
      this.actualizaPaso('colaboradores', 1);
    }
    if(refSteps.programacion != 1){
      this.actualizaPaso('programacion', 1);
    }
    if(refSteps.envio != 1){
      this.actualizaPaso('envio', 1);
    }
    if(refSteps.confirmacion != 1){this.actualizaPaso('confirmacion', 1); }
    if(refSteps.close != 1){ this.actualizaPaso('close', 1);  }
  }


}

configuraStepsFocus(){
  let statusActualizar = ["reactivos","adicionales","colaboradores","programacion","envio","close"];

  let lang = this.statusSteps.estatusSecciones.idiomas;
  let react = this.statusSteps.estatusSecciones.reactivos;
  let adic = this.statusSteps.estatusSecciones.adicionales;
  let colb = this.statusSteps.estatusSecciones.colaboradores;
  let prog = this.statusSteps.estatusSecciones.programacion;
  let envi = this.statusSteps.estatusSecciones.envio;
  let cier = this.statusSteps.estatusSecciones.close;

  if(lang == 3){
    if(react == 1){
      this.actualizaPaso(statusActualizar[0],2)
    }
    if(adic == 1){
      this.actualizaPaso(statusActualizar[1],2);
    }
    if(colb == 1){
      this.actualizaPaso(statusActualizar[2],2);
    }
    if(react == 3 && adic == 3 && colb == 3){
      if(prog == 1){
        this.actualizaPaso(statusActualizar[3],2);
      }
      if(prog == 3 && envi == 1){
        this.actualizaPaso(statusActualizar[4],2);
      }
      if(prog == 3 && envi == 3 && cier == 1){
        this.actualizaPaso(statusActualizar[5],2);
      }
    }
  }

}

actualizaPaso(paso:string, status:number){
console.log('paso',paso);
console.log('status',status);

  let datos: any = {};
  let anioProd: any;
  switch(this.tipoProducto){
    case "1": anioProd = localStorage.getItem('productoID'); break;
    case "2": anioProd = localStorage.getItem('productoID'); break;
    case "3": anioProd = localStorage.getItem('productoID'); break;
    case "4": anioProd = localStorage.getItem('productoID'); break;
    case "c1": case "c2": case "c3": case "m7": case "p1": case "f1": case "am1": case "td1": case "pe1":case "c4Plata": case "c6": anioProd = localStorage.getItem('productoID'); break;
    case "m1": case "m2": case "m3": case "m4": case "m5": case "m6": anioProd = localStorage.getItem('productoID'); break;
  }
  datos[paso] = status;
  console.log("datos a enviar:",datos);
  switch(this.tipoProducto){
    case "1": //certificarv1
    this.wizardService.guardaStatusStep(datos, anioProd).subscribe( (data: backInter.RespuestaGen) => {
      this.buscaCodigoSuccess(data);
    });
    break;
    case "c1": case "c2": case "c3": case "m7": case "p1": case "f1": case "am1": case "td1": case "pe1": case "c4Plata": case "c6": //certificar v2 y 3 nuevo instituto
    this.wizardService.guardaStatusStep(datos, anioProd).subscribe( (data: backInter.RespuestaGen) => {
      this.buscaCodigoSuccess(data);
    });
    break;
    case "2": //medir
    this.wizardService.guardaStatusStepMedir(datos, anioProd).subscribe( (data: backInter.RespuestaGen) => {
      console.log("data",data);

      this.buscaCodigoSuccess(data);
    });
    break;
    case "3": //PulseCheck
    this.wizardService.guardaStatusStepPulse(datos, anioProd).subscribe( (data: backInter.RespuestaGen) => {
      console.log(data);
      this.buscaCodigoSuccess(data);
    });
    break;
    case "4": //focus area
    this.wizardService.guardaStatusStepFocus(datos, localStorage.getItem('encuestaID')).subscribe( (data: backInter.RespuestaGen) => {
      this.buscaCodigoSuccess(data);
    });
    break;
    case "m1": case "m2": case "m3": case "m4": case "m5": case "m6": //nuevos medir
    this.wizardService.guardaStatusStepMedir(datos, anioProd).subscribe( (data: backInter.RespuestaGen) => {
      this.buscaCodigoSuccess(data);
    });
    break;
  }
}

buscaCodigoSuccess(data: backInter.RespuestaGen){
  console.log("buscaCodigoSuccess",data);

  let codigosSuccess = ['210','211','212','213','214','215','216','217','218', '220','222','221'];
  if(codigosSuccess.includes(data.message)){
    this.getTodosLosStatus();
  }
}

actualizaStatusStepWizard(){
  switch(this.tipoProducto){
    case "1": this.actualizaCertificar(); break;
    case "2": this.actualizaMedir(); break;
    //caso para pulse check
    case "3": this.actualizaPulse(); break;
    case "4": this.actualizaFocus(); break;
    case "c1": case "c2": this.actualizaCertificarT1(); break;
    case "c3": case "m7": case "p1": case "f1": case "am1": case "td1": case "pe1":case "c4Plata": case "c6": this.actualizaCertificarT3(); break;
    case "m2": case "m3": case "m4": case "m5": this.actualizaMedirT1(); break;
    case "m1":
    console.log("entro caso medir mejorado");
     this.actualizaMedirMejorado(); break;
    case "m6": this.actualizaMedirGenerico(); break;
    // case "3": anioProd = this.productoVigente.fechaPulseCheck; break;
  }
  //estados de pasos: 1=bloqueado, 2=desbloqueado 3=terminado

  this.stpAllOk = true;
  // console.log(this.pasosWizard);
}

actualizaCertificar(){
  this.pasosWizard.forEach( (step) => {
    switch(step.id){
      case 'idiomas': step.status = this.statusSteps.estatusSecciones.idiomas; break;
      case 'reactivos': step.status = this.statusSteps.estatusSecciones.reactivos; step.visible = this.hasReact; break;
      case 'forall': step.status = this.statusSteps.estatusSecciones.forall; step.visible = this.hasForall; break;
      case 'demo': step.status = this.statusSteps.estatusSecciones.demograficos; step.visible = this.hasDemog; break;
      case 'abiertas': step.status = this.statusSteps.estatusSecciones.abiertas; step.visible = this.hasOpen; break;
      case 'adic': step.status = this.statusSteps.estatusSecciones.adicionales; step.visible = this.hasAdici; break;
      case 'colabs': step.status = this.statusSteps.estatusSecciones.colaboradores; break;
      case 'prog': step.status = this.statusSteps.estatusSecciones.programacion; break;
      case 'envio': step.status = this.statusSteps.estatusSecciones.envio; break;
      case 'cierre': step.status = this.statusSteps.estatusSecciones.close; break;
    }
  });
}

actualizaCertificarT1(){
  console.log("Certificar 2.0");
  this.pasosWizard.forEach( (step) => {
    switch(step.id){
      case 'idiomas': step.status = this.statusSteps.estatusSecciones.idiomas; break;
      case 'nps': step.status = this.statusSteps.estatusSecciones.nps; step.visible = this.hasNpsT1; break;
      case 'reactivos': step.status = this.statusSteps.estatusSecciones.reactivos; step.visible = this.hasReactT1; break;
      case 'forall': step.status = this.statusSteps.estatusSecciones.forall; step.visible = this.hasForallT1; break;
      case 'control': step.status = this.statusSteps.estatusSecciones.control; step.visible = this.hasControlT1; break;
      case 'demo': step.status = this.statusSteps.estatusSecciones.demograficos; step.visible = this.hasDemogT1; break;
      case 'abiertas': step.status = this.statusSteps.estatusSecciones.abiertas; step.visible = this.hasOpenT1; break;
      case 'adic': step.status = this.statusSteps.estatusSecciones.adicionales; step.visible = this.hasAdiciT1; break;
      case 'encues': step.status = this.statusSteps.estatusSecciones.encuesta;break;
      case 'colabs': step.status = this.statusSteps.estatusSecciones.colaboradores; break;
      case 'prog': step.status = this.statusSteps.estatusSecciones.programacion; break;
      case 'envio': step.status = this.statusSteps.estatusSecciones.envio; break;
      case 'confirmacion': step.status = this.statusSteps.estatusSecciones.confirmacion; break;
      case 'cierre': step.status = this.statusSteps.estatusSecciones.close; break;
    }
  });
}

actualizaCertificarT3(){
  // console.log("Certificar 3.0");
  // console.log(this.pasosWizard);

  this.pasosWizard.forEach((paso) => {
    paso.status = this.statusSteps.estatusSecciones[paso.id];
    if(paso.idSeccion){
      paso.visible = this.seccionesDisponibles[paso.idSeccion];
    }
  });
  console.log("pasosWizardCT3:",this.pasosWizard);

}



actualizaMedirT1(){
  this.pasosWizard.forEach( (step) => {
    switch(step.id){
      case 'idiomas': step.status = this.statusSteps.estatusSecciones.idiomas; break;
      case 'nps': step.status = this.statusSteps.estatusSecciones.nps; step.visible = this.hasNpsT1; break;
      case 'reactivos': step.status = this.statusSteps.estatusSecciones.reactivos; step.visible = this.hasReactT1; break;
      //case 'forall': step.status = this.statusSteps.estatusSecciones.forall; step.visible = this.hasForallT1; break;
      case 'demo': step.status = this.statusSteps.estatusSecciones.demograficos; step.visible = this.hasDemogT1; break;
      case 'abiertas': step.status = this.statusSteps.estatusSecciones.abiertas; step.visible = this.hasOpenT1; break;
      case 'adic': step.status = this.statusSteps.estatusSecciones.adicionales; step.visible = this.hasAdiciT1; break;
      case 'encues': step.status = this.statusSteps.estatusSecciones.encuesta;break;
      case 'colabs': step.status = this.statusSteps.estatusSecciones.colaboradores; break;
      case 'prog': step.status = this.statusSteps.estatusSecciones.programacion; break;
      case 'envio': step.status = this.statusSteps.estatusSecciones.envio; break;
      case 'cierre': step.status = this.statusSteps.estatusSecciones.close; break;
    }
  });
  console.log("New pasos wizard");
  console.log(this.pasosWizard);
}

actualizaMedirMejorado(){


  this.pasosWizard.forEach( (step) => {
    // console.log('step',step);
    switch(step.id){
      case 'idiomas': step.status = this.statusSteps.estatusSecciones.idiomas; break;
      case 'nps': step.status = this.statusSteps.estatusSecciones.nps; step.visible = this.hasNpsT1; break;
      case 'reactivos': step.status = this.statusSteps.estatusSecciones.reactivos; step.visible = this.hasReactT1; break;
      //case 'forall': step.status = this.statusSteps.estatusSecciones.forall; step.visible = this.hasForallT1; break;
      case 'demo': step.status = this.statusSteps.estatusSecciones.demograficos; step.visible = this.hasDemogT1; break;
      case 'abiertas': step.status = this.statusSteps.estatusSecciones.abiertas; step.visible = this.hasOpenT1; break;
      case 'adic': step.status = this.statusSteps.estatusSecciones.adicionales; step.visible = this.hasAdiciT1; break;
      case 'encues': step.status = this.statusSteps.estatusSecciones.encuesta;break;
      case 'colabs': step.status = this.statusSteps.estatusSecciones.colaboradores; break;
      case 'prog': step.status = this.statusSteps.estatusSecciones.programacion; break;
      case 'envio': step.status = this.statusSteps.estatusSecciones.envio; break;
      case 'confirmacion': step.status = this.statusSteps.estatusSecciones.confirmacion; break;
      case 'cierre': step.status = this.statusSteps.estatusSecciones.close; break;
    }
  });
  // console.log("New pasos wizard");
  // console.log(this.pasosWizard);
}

actualizaMedirGenerico(){
  this.pasosWizard.forEach( (step) => {
    switch(step.id){
      case 'idiomas': step.status = this.statusSteps.estatusSecciones.idiomas; break;
      case 'reactivos': step.status = this.statusSteps.estatusSecciones.reactivos; step.visible = this.hasReactT1; break;
      case 'forall': step.status = this.statusSteps.estatusSecciones.forall; step.visible = this.hasForallT1; break;
      case 'nps': step.status = this.statusSteps.estatusSecciones.nps; step.visible = this.hasNpsT1; break;
      case 'demo': step.status = this.statusSteps.estatusSecciones.demograficos; step.visible = this.hasDemogT1; break;
      case 'abiertas': step.status = this.statusSteps.estatusSecciones.abiertas; step.visible = this.hasOpenT1; break;
      case 'adic': step.status = this.statusSteps.estatusSecciones.adicionales; step.visible = this.hasAdiciT1; break;
      case 'encues': step.status = this.statusSteps.estatusSecciones.encuesta;break;
      case 'colabs': step.status = this.statusSteps.estatusSecciones.colaboradores; break;
      case 'prog': step.status = this.statusSteps.estatusSecciones.programacion; break;
      case 'envio': step.status = this.statusSteps.estatusSecciones.envio; break;
      case 'cierre': step.status = this.statusSteps.estatusSecciones.close; break;
    }



  });
}

actualizaMedir(){
  this.pasosWizard.forEach( (step) => {
    switch(step.id){
      case 'idiomas': step.status = this.statusSteps.estatusSecciones.idiomas; break;
      case 'colabs': step.status = this.statusSteps.estatusSecciones.colaboradores; break;
      case 'prog': step.status = this.statusSteps.estatusSecciones.programacion; break;
      case 'envio': step.status = this.statusSteps.estatusSecciones.envio; break;
      case 'cierre': step.status = this.statusSteps.estatusSecciones.close; break;
    }
  });
}
//funcion para pulse check
actualizaPulse(){
  console.log(this.pasosWizard);

  this.pasosWizard.forEach( (step) => {
    switch(step.id){
      case 'idiomas': step.status = this.statusSteps.estatusSecciones.idiomas; break;
      case 'colabs': step.status = this.statusSteps.estatusSecciones.colaboradores; break;
      case 'prog': step.status = this.statusSteps.estatusSecciones.programacion; break;
      case 'envio': step.status = this.statusSteps.estatusSecciones.envio; break;
      case 'confirmacion': step.status = this.statusSteps.estatusSecciones.confirmacion; break;
      case 'cierre': step.status = this.statusSteps.estatusSecciones.close; break;
    }
  });
}
//funcion para Focus Area
actualizaFocus(){
  this.pasosWizard.forEach( (step) => {
    switch(step.id){
      case 'idiomas': step.status = this.statusSteps.estatusSecciones.idiomas; break;
      case 'reactivos': step.status = this.statusSteps.estatusSecciones.reactivos; break;
      case 'adic': step.status = this.statusSteps.estatusSecciones.adicionales; break;
      case 'colabs': step.status = this.statusSteps.estatusSecciones.colaboradores; break;
      case 'prog': step.status = this.statusSteps.estatusSecciones.programacion; break;
      case 'envio': step.status = this.statusSteps.estatusSecciones.envio; break;
      case 'cierre': step.status = this.statusSteps.estatusSecciones.close; break;
    }
  });
}

gotoStep(step): void
{
  this.animationDirection = this.currentStep < step ? 'left' : 'right';
  //this._changeDetectorRef.detectChanges();

  this.lastStep = this.currentStep;

  this.currentStep = step;

  // console.log(this.animationDirection);
  this.cambiaIdiomaVideo(this.idiomaActual,step);
}

gotoNextStep(): void
{
  // if ( this.currentStep === this.course.totalSteps - 1 )
  if ( this.currentStep === this.pasosWizard.length - 1 )
  {
    return;
  }
  this.animationDirection = 'left';
  //this._changeDetectorRef.detectChanges();
  this.currentStep++;
}

gotoPreviousStep(): void
{
  if ( this.currentStep === 0 )
  {
    return;
  }
  this.animationDirection = 'right';
  //this._changeDetectorRef.detectChanges();
  this.currentStep--;
}

toggleSidebar(name): void
{
  this._fuseSidebarService.getSidebar(name).toggleOpen();
}

aletaRestric(opc:number){
  let texto: string;
  switch(this.tipoProducto){
    case '1':
    switch(opc){
      case 1: case 2: case 3: case 4: case 5: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest1'; break;
      case 6: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest5'; break;
      case 7: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
      case 8: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest3'; break;
      case 9: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest4'; break;
    }
    break;
    case '2':
    switch(opc){
      case 1: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest1'; break;
      case 2: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
      case 3: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
      case 4: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
      case 5: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
    }
    break;
  }

  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
  Swal.fire({
    html: texto,
    icon: 'error',
    confirmButtonColor: '#e40601'
  });
}


// aletaRestric(opc:number){
//     let texto: string;
//     switch(opc){
//       case 1: case 2: case 3: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest1'; break;
//       case 4: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest5'; break;
//       case 5: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
//       case 6: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest3'; break;
//       case 7: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest4'; break;
//     }
//     this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
//     Swal.fire({
//       html: texto,
//       icon: 'error',
//       confirmButtonColor: '#e40601'
//     });
// }

}
